<template>
    <form @submit.prevent="checkEmail">
        <div>
            <jet-label for="email" value="Email" />
            <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus />
            <div v-if="form.errors.email" class="validation_error_msg">
                {{ form.errors.email }}
            </div>
        </div>

        <div class="flex items-center justify-end mt-4">
            <inertia-link :href="route('password.request')" class="underline text-sm text-gray-600 hover:text-gray-900">
                Forgot your password?
            </inertia-link>

            <jet-button class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Login
            </jet-button>
        </div>
    </form>
</template>

<script>
import JetLabel from "@/Jetstream/Label";
import JetInput from "@/Jetstream/Input";
import JetButton from "@/Jetstream/Button";

export default {
    components: {
        JetLabel,
        JetInput,
        JetButton,
    },
    props: {
        form: {
            type: Object,
            required: true,
        },
    },
    methods: {
        checkEmail() {
            this.form.errors = {}; // Clear previous errors
            axios
                .post(route("universal.find-tenants"), {
                    email: this.form.email,
                })
                .then((response) => {
                    if (response.data.status === "single_tenant") {
                        this.$emit("next", {
                            step: 2,
                            selectedTenant: response.data.tenant.id,
                        });
                    } else if (response.data.status === "multiple_tenants") {
                        this.$emit("next", {
                            step: 2,
                            tenants: response.data.tenants,
                            selectedTenant: response.data.tenants[0].id,
                            isMultipleTenants: true,
                        });
                        this.$emit("isMultipleTenants");
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.message) {
                        this.form.errors.email = error.response.data.message;
                    } else {
                        this.form.errors.email = "Something went wrong, please try again later.";
                    }
                });
        },
    },
};
</script>

<style scoped>
.validation_error_msg {
    font-weight: 400;
    margin: 6px 0 0 !important;
    color: red;
}
</style>
